import { create } from 'zustand';
import type { Tier } from '../data/types';

interface TiersStore {
  tiers: Tier[];
  tiersEnabled: boolean;
  setTiers: (tiers: Tier[]) => void;
  toggleTiersEnabled: () => void;
  addTier: (tier: Omit<Tier, 'id' | 'memberCount'>) => void;
  updateTier: (id: string, updates: Partial<Tier>) => void;
  removeTier: (id: string) => void;
  reorderTiers: (orderedIds: string[]) => void;
}

export const useTiers = create<TiersStore>((set) => ({
  tiers: [],
  tiersEnabled: true,
  setTiers: (tiers) => set({ tiers }),
  toggleTiersEnabled: () => set((state) => ({ tiersEnabled: !state.tiersEnabled })),
  addTier: (tier) =>
    set((state) => ({
      tiers: [
        ...state.tiers,
        { ...tier, id: crypto.randomUUID(), memberCount: 0 },
      ],
    })),
  updateTier: (id, updates) =>
    set((state) => ({
      tiers: state.tiers.map((t) => (t.id === id ? { ...t, ...updates } : t)),
    })),
  removeTier: (id) =>
    set((state) => ({
      tiers: state.tiers.filter((t) => t.id !== id),
    })),
  reorderTiers: (orderedIds) =>
    set((state) => ({
      tiers: state.tiers.map((t) => {
        const newRank = orderedIds.indexOf(t.id) + 1;
        return newRank > 0 ? { ...t, rank: newRank } : t;
      }),
    })),
}));
